import ButtonSecondary from './ButtonSecondary';

export default ButtonSecondary;
